import { ReactNode, useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import CommandPalette from './CommandPalette';
import ImpersonationBanner from './ImpersonationBanner';

export default function Layout({ children }: { children: ReactNode }) {
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen((o) => !o);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <ImpersonationBanner />
      <Header onOpenSearch={() => setPaletteOpen(true)} />
      <div className="flex flex-1">
        <aside className="hidden w-[280px] shrink-0 border-r border-gray-200 bg-gray-50 md:block">
          <Sidebar />
        </aside>
        <main className="flex-1 overflow-x-hidden px-6 py-8 md:px-12">
          {/* Jednotný container pro všechny stránky — drží konzistentní šířku a zarovnání
              breadcrumbs/nadpisů při přechodu mezi pohledy. Chapter detail si uvnitř dál
              shrinkne obsah na .prose-doc (720px) pro čitelnost a doplní pravostranný TOC. */}
          <div className="mx-auto w-full max-w-6xl">{children}</div>
        </main>
      </div>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </div>
  );
}
